export const getDictionaryFromArray = (array, key) => array.reduce(
    (obj, item) => ({
        ...obj,
        [item[key]]: item
    }),
    {}
);
export const getDictionaryFromArrayAsync = async (array, key) => array.reduce(
    (obj, item) => ({
        ...obj,
        [item[key]]: item
    }),
    {}
);

export const splitToChunks = (array, parts) => {
    const result = [];
    const arrayCopy = array.map(obj => ({...obj}));

    /* eslint-disable no-plusplus */
    for (let i = parts; i > 0; i-=1) {
        result.push(arrayCopy.splice(0, Math.ceil(arrayCopy.length / i)));
    }

    return result;
};

export const chunkArrayInGroups = (arr, size) => {
    const myArray = [];
    for(let i = 0; i < arr.length; i += size) {
        myArray.push(arr.slice(i, i+size));
    }
    return myArray;
}
